import { render, staticRenderFns } from "./SttrPD_Details.vue?vue&type=template&id=b1f6456c"
import script from "./SttrPD_Details.vue?vue&type=script&lang=js"
export * from "./SttrPD_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports